// src/api/models.ts
export type CreateTrainingJobIn = {
  dataset_id: number;
  model_name: string;
  arch: string;
  epochs: number;
  batch_size: number;
  learning_rate: number;
  augmentations?: string[];
  notes?: string;
};

export type CreateTrainingJobOut = {
  job_id: number;
  status: string;
};

export async function createTrainingJob(payload: CreateTrainingJobIn): Promise<CreateTrainingJobOut> {
  const res = await fetch("/api/models/train", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    throw new Error((await res.text().catch(() => "")) || "Failed to create training job");
  }
  return res.json();
}
